import { render, staticRenderFns } from "./AddAnchor.vue?vue&type=template&id=fb92a284&scoped=true&"
import script from "./AddAnchor.vue?vue&type=script&lang=js&"
export * from "./AddAnchor.vue?vue&type=script&lang=js&"
import style0 from "./AddAnchor.vue?vue&type=style&index=0&id=fb92a284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb92a284",
  null
  
)

export default component.exports